import { useEffect } from 'react'

import { openPopup, selectLocation, changePopupData, clearPotentialKind } from '../actions'
import { KINDS_WITH_MANDATORY_ATTRIBUTES } from '../constants'
import { activeLocationsSelector, potentialKindSelector } from '../selectors'
import { useDispatchValue, useStateValue } from '../state_provider'


export const PotentialKindPopup = () => {
  const dispatch = useDispatchValue()
  const state = useStateValue()
  const locations = activeLocationsSelector(state)
  const potentialKind = potentialKindSelector(state)

  useEffect(() => {
    const firstLocation = Object.values(locations)[0]
    const locationId = Object.keys(locations)[0]
    if (potentialKind && locationId && !firstLocation?.kind) {
      if (KINDS_WITH_MANDATORY_ATTRIBUTES.includes(potentialKind)) {
        dispatch(openPopup(locationId))
        dispatch(changePopupData({ kind: potentialKind }))
      } else {
        dispatch(selectLocation(locationId, potentialKind))
        clearPotentialKind()
      }
    }
  }, [dispatch, potentialKind, locations])

  return null
}
